<template>
    <form-modal
        :open="isAddModalOpen"
        :heading="$t('modals.subcategory.add')"
        entity="subcategory"
        mode="add"
        :submit-label="$t('modals.subcategory.save')"
        :fields="fields"
        save-url="/add-subcategory.php"
        :build-payload="buildPayload"
        @update:open="$emit('update:isAddModalOpen', $event)"
        @opened="fetchCategories"
        @saved="$emit('subcategory-saved')"
    />
</template>

<script>
import { computed } from 'vue';
import { useCategoryOptions } from '@/composables/useCategoryOptions';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isAddModalOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:isAddModalOpen', 'subcategory-saved'],
    setup() {
        const { categoryOptions, fetchCategories } = useCategoryOptions();

        const fields = computed(() => [
            { key: 'category_id', label: t('fields.category'), type: 'select', required: true, placeholder: t('placeholders.selectCategory'), options: categoryOptions.value },
            { key: 'subcategory_name', label: t('fields.subcategoryName'), type: 'text', required: true },
        ]);

        const buildPayload = (form) => ({
            subcategoryName: form.subcategory_name,
            categoryId: form.category_id,
        });

        return { fields, fetchCategories, buildPayload };
    },
};
</script>
